import { FC } from "react";
import { PatientProfileHeader } from "../../header/header";
import { QuickNavMenu } from "../../header/quick-nav-menu/quick-nav-menu";
import { ViewContent } from "../shared/view-content/view-content";
import { Box} from "@mui/system";
import {EnrollmentStatus} from "./enrollment-status";
import {usePatientConnect365} from "../../../../../../hooks/use-patient-connect-365/use-patient-connect365";
import {PatientConnectLogo} from "./PatientConnectLogo";
import {PatientConnectCardTitle} from "./patient-connect-card-title";
import {EnrollmentLink} from "./enrollment-link";

export const PatientConnect365View: FC = () => {
  const {
    pc365Enrollment,
    handleInviteClick,
    isPending,
    showEnrollmentStatus,
    showEnrollmentLink,
    statusBackgroundColor,
    statusLabel
  } = usePatientConnect365();

  const inviteLinkColor = pc365Enrollment.isReadyToSendEnrollment ? 'primary.main' : 'gray[500]';

    return (
      <>
        <PatientProfileHeader />
        <QuickNavMenu />
        <ViewContent>
              <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ margin: '20px 20px 0 20px' }}>
                <Box display="flex" alignItems="center">
                  <PatientConnectLogo />
                  <Box>
                    <PatientConnectCardTitle />
                  </Box>
                </Box>
                <EnrollmentStatus
                  statusLabel={statusLabel}
                  statusBackgroundColor={statusBackgroundColor}
                  showEnrollmentStatus={showEnrollmentStatus} />
              </Box>
          <EnrollmentLink
            handleInviteClick={handleInviteClick}
            inviteLinkColor={inviteLinkColor}
            isPending={isPending}
            showEnrollmentLink={showEnrollmentLink} />
        </ViewContent>
      </>
    );
}
